import { FilterDefinition } from '../types';

/**
 * Builds a parsers object from filter definitions for use with useQueryStates.
 * Converts an array of FilterDefinition objects into a Record where keys are filter IDs
 * and values are their corresponding parsers.
 *
 * @param filters - Array of filter definitions
 * @returns Record mapping filter IDs to their parsers
 */

export function buildFilterParsers(filters: FilterDefinition[]): Record<string, any> {
  return Object.fromEntries(filters.map((f) => [f.name, f.parser]));
}
